module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log-deleted-events text-dark"
  }, [_c('h2', {
    staticClass: "marg-5-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.deleted_log')) + " \"" + _vm._s(_vm.subject.name) + "\"")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', [(_vm.sortedLog.length < 1) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.no_lessons_deleted')))]) : _vm._e(), _vm._v(" "), (_vm.sortedLog.length > 0) ? _c('ul', {
    staticClass: "log-deleted-events__list"
  }, [_c('li', {
    staticClass: "log-deleted-events__event log-deleted-events__event__header"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.lesson')))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.deleted_subjects_log.deleted')))])])]), _vm._v(" "), _vm._l((_vm.sortedLog), function(logEvent) {
    return _c('li', {
      key: logEvent.id,
      staticClass: "log-deleted-events__event"
    }, [_c('div', {
      staticClass: "log-deleted-events__event__event-datetime subject-event",
      style: ({
        'backgroundColor': _vm.subject.color
      })
    }, [_vm._v("\n          " + _vm._s(logEvent.v_eventDate) + "\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top'
        }),
        expression: "{\n          arrow: true,\n          placement : 'top'\n                }"
      }],
      staticClass: "text-greyed",
      attrs: {
        "content": logEvent.v_formattedDate
      }
    }, [_c('span', {
      staticClass: "icon-bin text-greyed"
    }), _vm._v("\n          " + _vm._s(logEvent.name) + " -\n          " + _vm._s(logEvent.v_humanizedDate) + " " + _vm._s(_vm.$t('vue2.common.ago')) + "\n        ")])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66c82bcd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormLogDeletedEvents.vue
// module id = 1640
// module chunks = 1